// Shop code to put in the text: none when the shop has its own number.
export const textCode = (info) => (info?.ownNumber ? '' : info?.keyword || '');

// Trailing space leaves the cursor after PICKUP so the customer can add a time or note.
export const smsBody = (keyword) => `${keyword ? `${keyword} ` : ''}PICKUP `;

// "?&body=" is the form both iOS Messages and Android SMS apps accept.
export const smsHref = (number, keyword) =>
    `sms:${number}?&body=${encodeURIComponent(smsBody(keyword))}`;

// SMSTO QR payload: phone cameras open Messages with the number and text filled in.
export const smsQrPayload = (number, keyword) => `SMSTO:${number}:${smsBody(keyword)}`;
